import React from "react";
import { FaCheck } from "react-icons/fa";

interface SelectButtonProps {
  selected: boolean;
  onClick: () => void;
  label: React.ReactNode;
  variant?: "check" | "radio";
  className?: string;
}

export const SelectButton = ({
  selected,
  onClick,
  label,
  variant = "check",
  className = "",
}: SelectButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full
        text-left
        px-4
        py-2.5
        hover:bg-gray-50
        transition-colors
        flex
        items-center
        justify-between
        ${
          selected
            ? "bg-blue-50 text-blue-600 font-medium"
            : "text-gray-700"
        }
        ${className}
      `}
    >
      <span>{label}</span>
      {selected ? (
        variant === "check" ? (
          <FaCheck className="w-3 h-3 text-blue-600" />
        ) : (
          <div className="w-4 h-4 rounded-full border-2 border-blue-600 flex items-center justify-center">
            <div className="w-2 h-2 rounded-full bg-blue-600" />
          </div>
        )
      ) : (
        variant === "radio" && (
          <div className="w-4 h-4 rounded-full border-2 border-gray-300" />
        )
      )}
    </button>
  );
};
